<template>
    <div class="row">
        <div class="sm-12">
            <div v-for="unidade in unidades" :key="unidade.codigo">
                <p>
                    <strong>{{ unidade.descricao }}</strong>
                </p>
                <div class="responsive-table">
                    <table>
                        <thead>
                            <th align="left">Nome</th>
                            <th width="100">Tipo</th>
                            <th width="100">Mẽs/Ano</th>
                            <th width="100">Vencimento</th>
                            <th width="100" align="right">Valor</th>
                            <th width="100" align="right">Juros/Multa</th>
                            <th width="100" align="right">Total</th>
                        </thead>
                        <tbody>
                            <tr
                                v-for="boleto in unidade.boletos"
                                :key="boleto.codigo"
                            >
                                <td>{{ boleto.nome }}</td>
                                <td align="center">{{ boleto.tipoDOC }}</td>
                                <td align="center">{{ boleto.competencia }}</td>
                                <td align="center">
                                    {{ boleto.dataVencimento | date("dd/LL/yyyy") }}
                                </td>
                                <td align="right">{{ boleto.valor | currency }}</td>
                                <td align="right">{{ boleto.valorJMC | currency }}</td>
                                <td align="right">
                                    {{ boleto.valorAtualizado | currency }}
                                </td>
                            </tr>
                            <tr>
                                <td align="right" colspan="4">
                                    <strong>Subtotal</strong>
                                </td>
                                <td align="right">
                                    <strong>{{
                                        unidade.subtotal.valor | currency
                                    }}</strong>
                                </td>
                                <td align="right">
                                    <strong>{{
                                        unidade.subtotal.valorAtualizado | currency
                                    }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td align="right" colspan="4">
                                    <strong>Quantiade de Boletos</strong>
                                </td>
                                <td colspan="2">
                                    <strong>{{ unidade.boletos.length }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="responsive-table">
                <table>
                    <tr>
                        <td align="right" colspan="4"><strong>Total</strong></td>
                        <td align="right" width="100">
                            <strong>{{ total.valor | currency }}</strong>
                        </td>
                        <td align="right" width="100">
                            <strong>{{ total.valorAtualizado | currency }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td align="right" colspan="4"><strong>Quantidade de Boletos</strong></td>
                        <td colspan="2">
                            <strong>{{ quantidade_boletos }}</strong>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["unidades", "total"],
    filters: {
        currency(value) {
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        },
    },
    computed: {
        quantidade_boletos() {
            let total = 0
            for (let unidade of this.unidades) {
                total += unidade.boletos.length
            }
            return total
        }
    }
};
</script>

<style scoped>
@media print {
    
    /*
    table {
        break-inside: avoid !important;
    }

    
 
   

  

    thead { 
        display: table-row-group !important;
    }
    tfoot { 
        display: table-row-group !important; 
    }

    tr, td, thead, tfoot, tbody { page-break-inside: avoid !important; }
    */
    
    
    
}
</style>